export default {
  search: {
    resultMatchesBoxes: [],
  },
};
